(() => {

  //Listen to cart update event
  document.addEventListener(
    "cart:updated",
    () => {
      console.log(`%c cart:updated`, "color:green;font-size:30px;");
      validateAutoGWP();
    },
    false
  );

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET'
    })
    .then(response => response.json())
    .then((cart) => { //SUCCESS
      return cart;
    })
    .catch((error) => { //ERROR
      console.error(error);
    });
  }

  function removeGWPsFromCart(gwpItems) {
    const cartDrawer = document.querySelector('#CartDrawer');
    const cart = cartDrawer?.querySelector('cart-drawer');

    // Build POST body
    const updates = {}
    for(const gwpItem of gwpItems){
      updates[gwpItem.key] = 0;
    }
    const data = {
      updates,
      sections: cart.getSectionsToRender().map((section) => section.id)
    };

    fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then((response) => {
      if(window.autoAddGWPSettings.currentPage === 'cart'){
        window.location.reload();
      } else {
        if (cart) cart.renderContents(response);
      }
    })
    .catch((error) => {
      console.error(error);
    });

  }

  async function validateAutoGWP() {
    /*
    Check that cart has at least 1 item
    Iterate over each rule in the rules array
    For each rule:
      - Find existing GWP items in the cart items for this rule
      - Check if cart has eligible products for this rule
      - Add to batch of items to remove or add as needed
    Process batches with a single call each
    */

    // Skip if auto GWP is not enabled or there are no rules
    if (!window.autoAddGWPSettings || !window.autoAddGWPSettings.enabled || !window.autoAddGWPSettings.rules || !window.autoAddGWPSettings.rules.length) {
      return;
    }

    const cart = await fetchCart();

    // Collect items for batch processing
    const itemsToAdd = [];
    const itemsToRemove = [];

    // Process each rule independently
    for (const rule of window.autoAddGWPSettings.rules) {
      if (!rule.gwpProducts || !rule.gwpIncludedProducts) {
        continue; // Skip invalid rules
      }

      // Find GWP items for this rule
      const ruleGwpItems = cart.items.filter(item => {
        return rule.gwpProducts.find(product =>
          (product.id === item.product_id) &&
          (item.properties && item.properties["_is_auto_GWP"])
        );
      });

      // Find eligible items for this rule
      const ruleEligibleItems = cart.items.filter(item => {
        return rule.gwpIncludedProducts.find(product =>
          (product.id === item.product_id) &&
          (!item.properties || !item.properties["_is_auto_GWP"]) &&
          (!item.properties || !item.properties["_GWP"]) &&
          (!item.properties || !item.properties["_Bundle"])
        );
      });

      // If no eligible items but GWP items exist, add to removal batch
      if (ruleEligibleItems.length === 0 && ruleGwpItems.length > 0) {
        ruleGwpItems.forEach(item => itemsToRemove.push(item));
      }
      // If eligible items exist but no GWP items, add to addition batch
      else if (ruleEligibleItems.length > 0 && ruleGwpItems.length === 0) {
        // Add all GWP products for this rule
        for (let i = 0; i < rule.gwpProducts.length; i++) {
          const variantId = rule.gwpVariants[i];
          itemsToAdd.push({
            id: variantId,
            quantity: 1,
            properties: {
              "_is_auto_GWP": "auto-add-from-theme",
            }
          });
        }
      }
    }

    // Process batches
    if (itemsToRemove.length > 0) {
      removeGWPsFromCart(itemsToRemove);
    }

    if (itemsToAdd.length > 0) {
      window.addToCart(itemsToAdd);
    }
  }

})();
